'use client';

import { useQuery } from '@tanstack/react-query';
import { WATCHLIST_STATUS_KEY } from './watchlistCache';

/**
 * Subscribes to the shared watchlist status cache.
 * Returns the full map of { [id]: boolean }.
 * queryFn returns an empty object — actual data is written via setQueryData (seedWatchlistCache / setWatchlistStatus).
 */
export const useWatchlistStatus = () =>
  useQuery<Record<string, boolean>>({
    queryKey: WATCHLIST_STATUS_KEY,
    queryFn: () => ({}),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
